(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('direzione', {
            parent: 'entity',
            url: '/direzione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.direzione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/direzione/direziones.html',
                    controller: 'DirezioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('direzione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('direzione-detail', {
            parent: 'direzione',
            url: '/direzione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'gestioneAttiApp.direzione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/direzione/direzione-detail.html',
                    controller: 'DirezioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('direzione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Direzione', function($stateParams, Direzione) {
                    return Direzione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'direzione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('direzione-detail.edit', {
            parent: 'direzione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/direzione/direzione-dialog.html',
                    controller: 'DirezioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Direzione', function(Direzione) {
                            return Direzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('direzione.new', {
            parent: 'direzione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/direzione/direzione-dialog.html',
                    controller: 'DirezioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('direzione', null, { reload: 'direzione' });
                }, function() {
                    $state.go('direzione');
                });
            }]
        })
        .state('direzione.edit', {
            parent: 'direzione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/direzione/direzione-dialog.html',
                    controller: 'DirezioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Direzione', function(Direzione) {
                            return Direzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('direzione', null, { reload: 'direzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('direzione.delete', {
            parent: 'direzione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/direzione/direzione-delete-dialog.html',
                    controller: 'DirezioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Direzione', function(Direzione) {
                            return Direzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('direzione', null, { reload: 'direzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
